'use client'
import "@mantine/core/styles.css";
import '@mantine/dropzone/styles.css';
import React from "react";
import {
  MantineProvider,
  mantineHtmlProps,
  Text,
  Button,
} from "@mantine/core";
import { theme } from "../theme";
import "./global.css"
import { LanguageProvider } from "@components/i18n";
import ColorSchemeScriptClient from "./colorSchemeScript";
import AuthGuard from "@components/authGuard";
import { QueryClient, QueryClientProvider } from "react-query";
import { ContextModalProps, ModalsProvider } from "@mantine/modals";
import { IconExclamationCircle } from "@tabler/icons-react";
import '@mantine/dates/styles.css';
import { Notifications } from "@mantine/notifications";
import '@mantine/notifications/styles.css';
import '@mantine/tiptap/styles.css';
import dayjs from "dayjs";
import "dayjs/locale/id";
import relativeTime from "dayjs/plugin/relativeTime";
import calendar from "dayjs/plugin/calendar"
import customParseFormat from 'dayjs/plugin/customParseFormat';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import '@mantine/carousel/styles.css';
import ProviderMaintananceMode from "@components/@page/internal/settings/maintanance-mode/provider-maintanance-mode"


dayjs.extend(relativeTime);
dayjs.extend(calendar);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);
dayjs.extend(utc);
dayjs.extend(timezone);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false, // default: true
    },
  },
});
const ErrorFetchModal = ({
  context,
  id,
  innerProps,
}: ContextModalProps<{ modalBody: string }>) => (
  <>
    <div className="mb-4 w-full">
      <IconExclamationCircle size={78} color="red" className="m-auto" />
    </div>
    <Text size="sm">{innerProps.modalBody}</Text>
    <Button fullWidth mt="md" onClick={() => context.closeModal(id)}>
      Close
    </Button>
  </>
);

export default function RootLayout({ children }: { children: any }) {
  return (
    <html lang="en" {...mantineHtmlProps} >
      <head>
        <ColorSchemeScriptClient />
        <link rel="favicon" href="/favicon.svg" />
        <title>e-Procurement Tripatra</title>
        <meta
          name="viewport"
          content="minimum-scale=1, initial-scale=1, width=device-width, user-scalable=no"
        />

      </head>
      <body>
        <AuthGuard>
          <QueryClientProvider client={queryClient}>
            <MantineProvider theme={theme}>
              <ModalsProvider modals={{ ErrorFetchModal }}>
                <Notifications />
                <LanguageProvider>
                  <ProviderMaintananceMode>
                    {children}
                  </ProviderMaintananceMode>
                </LanguageProvider>
              </ModalsProvider>
            </MantineProvider>
          </QueryClientProvider>
        </AuthGuard>
      </body>
    </html>
  );
}
